import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { IdProductsState } from 'model/dashboardProducts/dProductsReducer';
import { InputCheckList, typeInputCheckboxItem } from 'components/UI/InputCheckboxList/InputCheckList';
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink';
import { logoutSagaAC } from 'model/system/systemActionCreators';
import { getStoreList } from 'model/dashboardStores/dStoresAPI';
import { IdStoresStateDataItem } from 'model/dashboardStores/dStoresReducer';
import { Alert } from 'components/UI/Alert/Alert';
import { Loader } from 'components/UI/Loader/Loader';
import { dProductsExportDataSagaAC } from 'model/dashboardProducts/dProductsActionCreators';
import { Transition } from '@headlessui/react';
import { ISystemState } from 'model/system/systemReducer';
import { languageForUrl } from 'locales/languages';


// Type
export type typePopupExportProducts = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const PopupExportProducts: React.FC<typePopupExportProducts> = ({ variant, setOpenPopup }) => {

    const dispatch = useDispatch()

    // get lang from store
    const lang = useSelector((state:  { system: ISystemState }) => state.system.language)

    const productsList = useSelector((state: { dProducts: IdProductsState }) => state.dProducts.data)


    const [ stores, setStores ] = useState<typeInputCheckboxItem[]>([])
    const [ loader, setLoader ] = useState(false)
    const [ openStore, setOpenStore ] = useState(false)

    // Did mount
    useEffect(() => {
        const setData = async () => {
            setLoader(true)
            let responseStores = await getStoreList({ filters: { name: null, deleted: false }, full: false })

            if (responseStores.status === 200) {
                const mappingData: typeInputCheckboxItem[] = responseStores.data.map((item: IdStoresStateDataItem) => ( {
                    id: item.id,
                    name: item.name,
                    label: item.name,
                    // value: item.address,
                    checked: false,
                    itemDeleted: item.deleted

                } ))
                setStores(mappingData)
            } else if (responseStores.status === 401) {
                dispatch(logoutSagaAC())
            }
            setLoader(false)
        }
        setData().then(() => setLoader(false))

        // eslint-disable-next-line
    }, [])

    const onSelectStoreClick = () => {
        setOpenStore(true)
    }

    const onCloseSelectStoreClick = () => {
        setOpenStore(false)
        onResetSelectedHandler()
    }

    const onSelectAllHandler = () => {
        const newStores = stores.map(item => ( { ...item, checked: true } ))
        setStores(newStores)
    }

    const onResetSelectedHandler = () => {
        const newStores = stores.map(item => ( { ...item, checked: false } ))
        setStores(newStores)
    }

    const onExportHandler = (e: React.FormEvent) => {
        e.preventDefault()

        const idsStores = stores.reduce((acc: string[], cur) => {
            if (cur.checked) {
                acc.push(cur.id)
            }
            return acc
        }, [])

        const idsProducts = productsList.filter(item => item.checked).map(item => item.id)



        dispatch(dProductsExportDataSagaAC(idsProducts, idsStores, languageForUrl[lang]))

        setOpenPopup(false)
    }


    return (
        <form onSubmit={ (e) => onExportHandler(e) }
              className={ 'w-80vw flex flex-col gap-4' }>
            <Alert type={ 'info' } title={ <Trans>Export of goods from certain stores is available.</Trans> }
                   messages={ [ <Trans> if no store is selected, then all products will be exported (including those not
                       linked to stores)</Trans>,
                       <Trans> all stores are selected, then goods associated with stores will be exported, goods
                           without stores will not be included in the export</Trans>, ] }
            />
            <div className={ 'mt-4' }>
                <div className={ 'flex flex-wrap  gap-6' }>
                    <Button secondary={ true } type={ 'button' } label={ !openStore ? <Trans>Select stores</Trans> :
                        <Trans>Close selecting store</Trans> }
                            onClick={ openStore ? onCloseSelectStoreClick : onSelectStoreClick }
                    />
                </div>

                    <div className={ '' }>
                        <Transition.Root
                            show={ openStore }
                            as={ 'div' }
                        >
                        <Transition.Child
                            as={ 'div' }
                            enter="ease-in-out duration-300"
                            enterFrom="opacity-0 "
                            enterTo="opacity-100 "
                            leave="ease-in-out duration-300"
                            leaveFrom="opacity-100 "
                            leaveTo="opacity-0 "
                        >
                            <div className={ 'flex mb-2 justify-between items-end px-1 mt-4' }>
                                <h3 className={ 'font-medium text-gray-900' }><Trans>Store's list</Trans></h3>
                                <div className={ 'flex flex-wrap gap-4 text-sm font-medium' }>
                                    <ButtonLink type={ 'button' } label={ <Trans>Select all</Trans> }
                                                onClick={ onSelectAllHandler }/>
                                    <ButtonLink type={ 'button' } label={ <Trans>Reset selection</Trans> }
                                                onClick={ onResetSelectedHandler }/>
                                </div>
                            </div>
                            <div className={ 'flex flex-col gap-1' }>
                                <div>
                                    { stores.length > 0 ?
                                        <InputCheckList dataList={ stores }
                                                        setDataList={ setStores }
                                                        labelClassName={ 'break-all' }
                                                        fieldsetClassName={ 'grid grid-cols-3 gap-2' }/>
                                        : <Alert type={ 'info' } title={ <Trans>Have no data</Trans> }/>
                                    }
                                    { loader && <Loader/> }
                                </div>
                            </div>
                        </Transition.Child>
                        </Transition.Root>
                    </div>





            </div>


            <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                <Button type="submit" variant={ variant }
                        label={ <Trans>Export</Trans> }/>
                <Button type="button" secondary={ true } label={ <Trans>Close</Trans> }
                        onClick={ () => setOpenPopup(false) }/>
            </div>

        </form>
    )
}
